import UserTypes from '../../enums/UserTypes';
import ARBRealizarOrcamento from '../../views/balconista/RealizarOrcamento.vue';
import ARBalconista from '../../views/balconista/Index.vue';
import ARBMeusDados from '../../views/balconista/MeusDados.vue';
import ARBMeusSaldos from '../../views/balconista/MeusSaldos.vue';
import ARBOrcamentoRealizado from '../../views/balconista/OrcamentoRealizado.vue';
// Menu
import CustomizationSocialMedia from '../../views/lojista/customizations/SocialMedias.vue';
// import ArtesSocialMedia from '../../views/lojista/artesRedesSociais/Index.vue';
// import CartaoCredito from '../../views/lojista/CartaoCredito.vue';
import CustomizationAbout from '../../views/lojista/customizations/About.vue';
import NewMenuHome from '../../views/lojista/customizations/NewMenuHome.vue';
import SelectProducts from '../../views/lojista/products/SelectProducts.vue';
import SelectedProducts from '../../views/lojista/products/SelectedProducts.vue';
import ClientList from '../../views/lojista/clients/List.vue';
import DashboardHome from '../../views/lojista/dashboard/Home.vue';
import ChangeColor from '../../views/lojista/customizations/ChangeColor/Index.vue';
import SaveBanner from '../../views/lojista/customizations/Banner/Save.vue';
import ListBanner from '../../views/lojista/customizations/Banner/List.vue';
import OrdersAppList from '../../views/lojista/orders-app/List.vue';
import CartAbandonedAppList from '../../views/lojista/orders-app/CarrinhoAbondonado.vue';
import FreightSave from '../../views/lojista/freight/Save.vue';
import SuggestProduct from '../../views/lojista/products/SuggestProduct.vue';
import InsertProduct from '../../views/lojista/products/InsertProduct.vue';
import AppTipoClientes from '../../views/lojista/products/AppTipoClientes.vue';
import PaymentMethodsSave from '../../views/lojista/payment-methods/Save.vue';
import WalletApp from '../../views/lojista/payment-methods/WalletApp.vue';
import StatisticsDashboard from '../../views/administrador/shopkeeper-app/ordersLojista/List.vue';
import SaveNotification from '../../views/lojista/notifications/Save.vue';
import ListNotification from '../../views/lojista/notifications/List.vue';
import ListApprovementRequests from '../../views/lojista/professional/approvement-requests/List.vue';
import ReportFacebookAds from '../../views/lojista/report/ReportFacebookAds.vue';
import ClerkApp from '../../views/lojista/clerk-app/Clerk.vue';
import ReportGoogleAnalytics from '../../views/lojista/report/ReportGoogleAnalytics.vue';
import ReportWhatsAppClicks from '../../views/lojista/report/ReportWhatsAppClicks.vue';
import ReportLinktreeClicks from '../../views/lojista/report/ReportLinktreeClicks.vue';
import VerMeuApp from '../../views/lojista/VerMeuApp.vue';
import ListFlyers from '../../views/lojista/flyers/List.vue';
import OrcamentoWhatsapp from '../../views/lojista/OrcamentoWhatsapp.vue';
import CouponDiscount from '../../views/lojista/coupon/CouponDiscount.vue';
import ListNotificationWhatsapp from '../../views/lojista/notifications/WhatsApp.vue';
import ListNotificationNewsletter from '../../views/lojista/notifications/Newsletter.vue';
import ListPromptAgentIA from '../../views/lojista/notifications/ListPromptAgentIa.vue';
import NotificationAppCms from '../../views/lojista/notifications/AppCms.vue';
import WaitingProduct from '../../views/lojista/products/WaitingProduct.vue';
import ProductSearch from '../../views/lojista/products/ProductSearch.vue';
import ProductBoost from '../../views/lojista/products/ProductBoost.vue';
import ProductsBestSellers from '../../views/lojista/products/ProductsBestSellers.vue';

export default [
  {
    path: '/area-restrita/balconista',
    name: 'balconista',
    component: ARBalconista,
    children: [
      {
        path: '/area-restrita/balconista/meus-dados',
        name: 'balconista-meus-dados',
        component: ARBMeusDados,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/meus-saldos',
        name: 'balconista-meus-saldos',
        component: ARBMeusSaldos,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/realizar-orcamento',
        name: 'balconista-realizar-orcamento',
        component: ARBRealizarOrcamento,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/orcamento-realizado',
        name: 'balconista-orcamento-realizado',
        component: ARBOrcamentoRealizado,
        meta: { userType: UserTypes.BALCONISTA },
      },

      // NOVAS ROTAS
      {
        path: '/area-restrita/balconista/customizacoes/redes-sociais',
        name: 'balconista-customizacoes-redes-sociais',
        props: true,
        component: CustomizationSocialMedia,
        meta: { userType: UserTypes.BALCONISTA },
      },
      // {
      //   path: '/area-restrita/balconista/artes-redes-sociais',
      //   name: 'balconista-artes-redes-sociais',
      //   props: true,
      //   component: ArtesSocialMedia,
      //   meta: {userType: UserTypes.BALCONISTA },
      // },
      // {
      //   path: '/area-restrita/balconista/cartao-de-credito/:id',
      //   name: 'balconista-cartão-credito',
      //   props: true,
      //   component: CartaoCredito,
      //   meta: {userType: UserTypes.BALCONISTA },
      // },
      {
        path: '/area-restrita/balconista/produtos-buscados',
        name: 'balconista-product-search',
        props: true,
        component: ProductSearch,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/produtos-impusionar',
        name: 'balconista-product-boost',
        props: true,
        component: ProductBoost,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/produtos-mais-comprados',
        name: 'balconista-best-sellers',
        props: true,
        component: ProductsBestSellers,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/customizacoes/sobre-empresa',
        name: 'balconista-customizacoes-sobre-empresa',
        props: true,
        component: CustomizationAbout,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/produtos/selecao',
        name: 'balconista-produtos-selecao',
        props: true,
        component: SelectProducts,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/produtos/selecionados',
        name: 'balconista-produtos-selecionados',
        props: true,
        component: SelectedProducts,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/criar-produtos',
        name: 'balconista-produtos-criar',
        props: true,
        component: InsertProduct,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/produtos/suggest',
        name: 'balconista-produtos-suggest',
        props: true,
        component: SuggestProduct,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/tipo-clientes',
        name: 'balconista-app-tipo-clientes',
        props: true,
        component: AppTipoClientes,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/clientes',
        name: 'balconista-clientes',
        props: true,
        component: ClientList,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/home',
        name: 'balconista-app-home',
        props: true,
        component: DashboardHome,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/produtos/wainting',
        name: 'balconista-wainting-product',
        props: true,
        component: WaitingProduct,
        meta: { userType: UserTypes.SHOPKEEPER },
      },
      {
        path: '/area-restrita/balconista/customizacoes/mudar-cor',
        name: 'balconista-customizacoes-mudar-cor',
        props: true,
        component: ChangeColor,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/customizacoes/criar-categoria',
        name: 'balconista-customizacoes-criar-categoria',
        props: true,
        component: NewMenuHome,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/customizacoes/banners',
        name: 'balconista-customizacoes-banners',
        props: true,
        component: ListBanner,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/customizacoes/flyers',
        name: 'balconista-customizacoes-flyers',
        props: true,
        component: ListFlyers,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/relatorio/google-analytics',
        name: 'balconista-report-google-analytics',
        props: true,
        component: ReportGoogleAnalytics,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/relatorio/whatsapp-clicks',
        name: 'balconista-report-whatsapp-clicks',
        props: true,
        component: ReportWhatsAppClicks,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/relatorio/linktree-clicks',
        name: 'balconista-report-linktree-clicks',
        props: true,
        component: ReportLinktreeClicks,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/google-shopping',
        name: 'balconista-google-shopping',
        props: true,
        component: () => import('@/views/lojista/google-shopping/Index.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/tiny',
        name: 'balconista-app-tiny',
        props: true,
        component: () => import('@/views/lojista/tiny/Index.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/marketplaces',
        name: 'balconista-app-marketplaces',
        props: true,
        component: () => import('@/views/lojista/marketplaces/Index.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/erp',
        name: 'balconista-app-erp',
        props: true,
        component: () => import('@/views/lojista/erp/Index.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/erp/integrar-produtos',
        name: 'balconista-app-erp-integrar-produtos',
        props: true,
        component: () => import('@/views/lojista/erp/IntegrateProducts.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/erp/acompanhar-integracao',
        name: 'balconista-app-erp-acompanhar-integracao',
        props: true,
        component: () =>
          import('@/views/lojista/erp/ListProductIntegrations.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/marketplaces/integrar-produtos',
        name: 'balconista-app-marketplaces-integrar-produtos',
        props: true,
        component: () =>
          import('@/views/lojista/marketplaces/IntegrateProducts.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/marketplaces/acompanhar-integracao',
        name: 'balconista-app-marketplaces-acompanhar-integracao',
        props: true,
        component: () =>
          import('@/views/lojista/marketplaces/ListProductIntegrations.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/customizacoes/banner/:id?',
        name: 'balconista-customizacoes-salvar-banner',
        props: true,
        component: SaveBanner,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/pedidos-app',
        name: 'balconista-pedidos-app',
        props: true,
        component: OrdersAppList,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/carrinho-abandonado',
        name: 'balconista-carrinho-abondonado',
        props: true,
        component: CartAbandonedAppList,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app-clerk',
        name: 'app-clerk',
        props: true,
        component: ClerkApp,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/frete-app',
        name: 'balconista-frete-app',
        props: true,
        component: FreightSave,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/meios-de-pagamento',
        name: 'balconista-app-meios-pagamentos',
        props: true,
        component: PaymentMethodsSave,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/carteira',
        name: 'balconista-app-carteira',
        props: true,
        component: WalletApp,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/estatisticas',
        name: 'balconista-app-estatisticas',
        props: true,
        component: StatisticsDashboard,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/bolconista/relatorio/facebook-ads',
        name: 'bolconista-report-facebook-ads',
        props: true,
        component: ReportFacebookAds,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/notificacoes',
        name: 'balconista-app-notificacoes',
        props: true,
        component: ListNotification,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/notificacoes/:id?',
        name: 'balconista-app-salvar-notificacao',
        props: true,
        component: SaveNotification,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/profissionais/solicitacoes',
        name: 'balconista-app-profissionais-solicitacoes',
        props: true,
        component: ListApprovementRequests,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/promocoes-digitais',
        name: 'balconista-app-promocoes-digitais',
        props: true,
        component: () =>
          import('@/views/lojista/digital-promotions/SaveDigitalPromotion.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/pixel-facebook',
        name: 'balconista-pixel-facebook',
        props: true,
        component: () =>
          import('@/views/lojista/customizations/PixelFacebook.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/ferramentas-analise',
        name: 'balconista-ferramentas-analise',
        props: true,
        component: () =>
          import('@/views/lojista/customizations/AnalyticsTools.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/campanha-sorteio',
        name: 'balconista-campanha-sorteio',
        props: true,
        component: () => import('@/views/lojista/raffleCampaign/Index.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/ver-app',
        name: 'balconista-ver-app',
        props: true,
        component: VerMeuApp,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/orcamento-whatsapp',
        name: 'orcamento-whatsapp',
        props: true,
        component: OrcamentoWhatsapp,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/cupom-de-desconto',
        name: 'balconista-app-cupom-desconto',
        props: true,
        component: CouponDiscount,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/cupom-de-cashback',
        name: 'balconista-app-cupom-cashback',
        props: true,
        component: CouponDiscount,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/notificacoes-whatsapp',
        name: 'balconista-app-notificacoes-whatsapp',
        props: true,
        component: ListNotificationWhatsapp,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/newsletter-app-notificacoes',
        name: 'newsletter-app-notificacoes',
        props: true,
        component: ListNotificationNewsletter,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/agente-ia',
        name: 'balconista-app-agente-ia',
        props: true,
        component: ListPromptAgentIA,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/notificacoes-cms',
        name: 'balconista-app-notificacoes-cms',
        props: true,
        component: NotificationAppCms,
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/balconista/app/webhooks',
        name: 'balconista-app-webhooks',
        props: true,
        component: () => import('@/views/lojista/webhooks/List.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/app/webhooks/integracao/:id?',
        name: 'balconista-app-webhooks-integracao',
        props: true,
        component: () => import('@/views/lojista/webhooks/Save.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/app/termos-condicoes',
        name: 'balconista-termos-condicoes',
        props: true,
        component: () => import('@/views/lojista/customizations/Terms.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/app/politica-devolucao',
        name: 'balconista-politica-devolucao',
        props: true,
        component: () =>
          import('@/views/lojista/customizations/ReturnPolicy.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/app/privacidade',
        name: 'balconista-privacidade',
        props: true,
        component: () => import('@/views/lojista/customizations/Privacy.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/services',
        name: 'balconista-service-insert',
        component: () => import('@/views/lojista/services/ListServices.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/anti-fraud',
        name: 'balconista-app-anti-fraud',
        props: true,
        component: () => import('@/views/lojista/anti-fraud/Index.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
      {
        path: '/area-restrita/lojista/anti-fraud/pedidos',
        name: 'balconista-app-anti-fraud-pedidos',
        props: true,
        component: () => import('@/views/lojista/anti-fraud/OrdersList.vue'),
        meta: { userType: UserTypes.BALCONISTA },
      },
    ],
  },
];
